import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface NoShowUserStat {
  userId: string;
  firstName: string;
  lastName: string | null;
  totalReports: number;
  dinnersWithMultipleReports: number;
}

export function useAdminNoShows() {
  return useQuery({
    queryKey: ['admin-no-shows'],
    queryFn: async () => {
      return api.get<NoShowUserStat[]>('/admin/connections/no-shows');
    },
  });
}
